import { render, staticRenderFns } from "./KCglpage.vue?vue&type=template&id=2bde61ce&scoped=true&"
import script from "./KCglpage.vue?vue&type=script&lang=js&"
export * from "./KCglpage.vue?vue&type=script&lang=js&"
import style0 from "./KCglpage.vue?vue&type=style&index=0&id=2bde61ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde61ce",
  null
  
)

export default component.exports